"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OfferStep = void 0;
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _Offer = require("../Offer");
var _OfferStepSkeleton = require("../OfferStepSkeleton");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component to render offers.
 * If useOffers returns loading on true, it will render skeleton with animation.
 * If there are no offers and loading is false, it will render a skeleton without animation.
 */ const OfferStep = ()=>{
    const { loading, offers } = (0, _hooks.useOffers)();
    if (loading || offers.length === 0) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OfferStepSkeleton.OfferStepSkeleton, {
            animation: loading ? 'pulse' : false
        });
    }
    // istanbul ignore next -- do not need to test this, all contents are tested separately
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_contexts.CheckoutOffersProvider, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
            children: offers.map((offer)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_Offer.Offer, {
                    offer: offer
                }, offer.choiceId))
        })
    });
};
exports.OfferStep = OfferStep;
